module.exports = __webpack_public_path__ + "img/bmh_地图.12576bb5.png";